import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem, HeaderAction } from '@shared/components/navigation/types';
import { usePermissions } from '@shared/hooks/usePermissions';

interface WithdrawalsBreadcrumbProps {
  headerActions?: HeaderAction[];
}

export const WithdrawalsBreadcrumb = ({ headerActions }: WithdrawalsBreadcrumbProps) => {
  const { t: tWithdrawals } = useTranslation('withdrawalsModule');
  const { t: tWallets } = useTranslation('walletsModule');
  const { getTeamType } = usePermissions();
  const teamType = getTeamType();
  const isExternal = teamType === 'tenant_external';

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const items: BreadcrumbItem[] = [];

    if (isExternal) {
      items.push({
        label: tWallets('breadcrumbs.wallet'),
        path: '/wallets',
      });
    }

    items.push({
      label: tWithdrawals('breadcrumbs.withdrawals'),
    });

    return items;
  }, [tWithdrawals, tWallets, isExternal]);

  usePageNavigation({ breadcrumbs, headerActions });

  return null;
};
